export default __webpack_public_path__ + "static/media/back_grey.61dfc80a.svg";